module.exports = __webpack_public_path__ + "static/media/unlock.b540506b.svg";